__turbopack_context__.v({
  "--has-pagination-controls": "entry-images-modal-module-scss-module__JdDE3W__--has-pagination-controls",
  "--is-desktop-sidebar": "entry-images-modal-module-scss-module__JdDE3W__--is-desktop-sidebar",
  "--is-mobile-full-screen": "entry-images-modal-module-scss-module__JdDE3W__--is-mobile-full-screen",
  "--next": "entry-images-modal-module-scss-module__JdDE3W__--next",
  "--previous": "entry-images-modal-module-scss-module__JdDE3W__--previous",
  "__below-image-controls": "entry-images-modal-module-scss-module__JdDE3W____below-image-controls",
  "__button": "entry-images-modal-module-scss-module__JdDE3W____button",
  "__clickable-area": "entry-images-modal-module-scss-module__JdDE3W____clickable-area",
  "__gallery": "entry-images-modal-module-scss-module__JdDE3W____gallery",
  "__image": "entry-images-modal-module-scss-module__JdDE3W____image",
  "__on-image-controls": "entry-images-modal-module-scss-module__JdDE3W____on-image-controls",
  "__overlay": "entry-images-modal-module-scss-module__JdDE3W____overlay",
  "entry-images-modal": "entry-images-modal-module-scss-module__JdDE3W__entry-images-modal",
});
